import { useLocation } from 'react-router';
import { type AppointmentsReserveLocationState } from 'pages/AppointmentsReserve/types';

/**
 * Reads the navigation state of the reserve route. `useLocation` types `state` as `any`,
 * so this is the single place where it is narrowed to the shape the callers send.
 */
export const useReserveLocationState = (): AppointmentsReserveLocationState => {
  const { state } = useLocation();
  return (state ?? {}) as AppointmentsReserveLocationState;
};
